export class UserCreateModel {
    loginEmail: string;
    clientShortName: string;
    employeeIdentifier: string;
    positionName: string;
}
